import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { getIsFiniteNumber } from '../primitive-utils';
import { ProjectService } from '../services/project.service';

export const projectIdResolver: ResolveFn<Observable<boolean>> = (
  currentRoute: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
) => {
  const projectId = Number(currentRoute.paramMap.get('projectId'));
  const projectService = inject(ProjectService);

  if (getIsFiniteNumber(projectId)) {
    projectService.setCurrentProjectById(projectId);
  }

  return toObservable(projectService.projectStore.isLoading).pipe(map(val => !val));
};
